var $d7f8e6da366bff75$exports = {};
document.querySelectorAll('.sidebar li a').forEach((element)=>{
    element.classList.remove('bg-active', 'text-active-text');
});
document.querySelectorAll('.sidebar li:nth-child(7) a').forEach((element)=>{
    element.classList.add('bg-active', 'text-active-text');
}); // import("./breadcrumbs.js").then(function (breadcrumb) {
 //     breadcrumb.setCrumbs({
 //         1: {
 //             href: "series.html",
 //             text: "Series"
 //         },
 //         2: {
 //             href: "",
 //             text: "GT3 Endurance"
 //         }
 //     });
 // });


//# sourceMappingURL=2026-4-hours-at-thruxton-presented-by-thrustmaster.77b221f2.js.map
